import type { SacristanContact as SacristanContactData } from "../types/dashboard";

interface Props {
  sacristan: SacristanContactData | null;
  onDraftEmail: () => void;
}

export default function SacristanContact({ sacristan, onDraftEmail }: Props) {
  if (!sacristan) {
    return (
      <section className="sacristan-card" aria-labelledby="sacristan-title">
        <h2 id="sacristan-title" className="sacristan-card__title">
          Sacristan for this Mass
        </h2>
        <p className="panel__empty">No sacristan assigned.</p>
      </section>
    );
  }

  return (
    <section className="sacristan-card" aria-labelledby="sacristan-title">
      <h2 id="sacristan-title" className="sacristan-card__title">
        Sacristan for this Mass
      </h2>
      <div className="sacristan-card__row">
        <div className="sacristan-card__info">
          <p className="sacristan-card__name">{sacristan.name}</p>
          {sacristan.email ? (
            <p className="sacristan-card__line">{sacristan.email}</p>
          ) : null}
          {sacristan.phone ? (
            <p className="sacristan-card__line">{sacristan.phone}</p>
          ) : null}
        </div>
        <div className="sacristan-card__action">
          <button type="button" className="btn" onClick={onDraftEmail}>
            Draft email to sacristan
          </button>
        </div>
      </div>
    </section>
  );
}
